import React, { memo } from 'react';
var GradientFilter = function (_a) {
    var filterId = _a.filterId, positiveColor = _a.positiveColor, zeroPointColor = _a.zeroPointColor, negativeColor = _a.negativeColor, gradientZeroPercent = _a.gradientZeroPercent;
    return (React.createElement("linearGradient", { id: filterId, x1: "0%", y1: "0%", x2: "0%", y2: "100%" },
        React.createElement("stop", { offset: "0%", style: { stopColor: positiveColor } }),
        React.createElement("stop", { offset: gradientZeroPercent + "%", style: { stopColor: zeroPointColor } }),
        React.createElement("stop", { offset: "100%", style: { stopColor: negativeColor } })));
};
export default memo(GradientFilter);
